<ul>
	<li class="visible-mobile">
		<a [routerLink]="[currentLang]" (click)="onClickItemMenu()">{{ "MENU.MAIN" |
			translate }}</a>
	</li>
	<li [class.active]="ifActiveSubmenuWorks">
		<a
			[routerLink]="[currentLang,'work']"
			(click)="onClickItemMenuWorks()"
			[class.active]="isActive([currentLang,'work'])">
			{{
			"MENU.WORK.TEXT"
			| translate
			}}
		</a>
		<div class="submenu">
			<filter-works-list (clickItemMenu)="onClickItemMenu()"></filter-works-list>
		</div>
	</li>
	<li [class.active]="ifActiveSubmenuClients">
		<a [routerLink]="[currentLang,'clients']" (click)="onClickItemMenuClients()" [class.active]="isActive([currentLang,'clients'])"
			>{{
			"MENU.CLIENTS.TEXT" |
			translate }}</a>
		<div class="submenu">
			<filter-clients-list (clickItemMenu)="onClickItemMenu()"></filter-clients-list>
		</div>
	</li>
	<li><a [routerLink]="[currentLang,'people']" (click)="onClickItemMenu()" [class.active]="isActive([currentLang,'people'])">{{
			"MENU.PEOPLE" |
			translate }}</a></li>
	<li><a [routerLink]="[currentLang,'about']" (click)="onClickItemMenu()" [class.active]="isActive([currentLang,'about'])">{{
			"MENU.ABOUT" |
			translate }}</a></li>
	<li><a [routerLink]="[currentLang,'contacts']" (click)="onClickItemMenu()" [class.active]="isActive([currentLang,'contacts'])">{{
			"MENU.CONTACTS" |
			translate }}</a></li>
	<li><a [routerLink]="[currentLang,'education']" (click)="onClickItemMenu()" [class.active]="isActive([currentLang,'education'])">{{
			"MENU.EDUCATION" |
				translate }}</a></li>
	<li class="visible-mobile">
		<a *ngIf="!currentLang.length" (click)="toggleLang('en')">EN</a>
		<a *ngIf="currentLang.length" (click)="toggleLang()">RU</a>
	</li>
</ul>
